import React from 'react';
import useFreeResiliationFormulaContext from '../../Contexts/FreeResiliationFormulaContext/useFreeResiliationFormulaContext';
import ContractBreachResults from './Components/ContractBreachResults';
import CurrentCostResults from './Components/CurrentCostResults';
import NewCostResults from './Components/NewCostResults';
import Savings from './Components/Savings';
import StyledBox from './styles';

export default function Results() {
  const {
    currentOfferCost, terminationFees,
  } = useFreeResiliationFormulaContext();
  const [expanded, setExpanded] = React.useState<string | null>(null);
  const expandProps = (value: string) => (
    {
      expand() { if (expanded === value) { setExpanded(null); } else { setExpanded(value); } },
      expanded: expanded === value,
    }
  );
  if (currentOfferCost === undefined || terminationFees === undefined) return null;

  return (
    <StyledBox>
      <CurrentCostResults currentOfferCost={currentOfferCost} {...expandProps('currentCost')} />
      <ContractBreachResults terminationFees={terminationFees} {...expandProps('fees')} />
      <NewCostResults {...expandProps('newCost')} />
      <Savings />
    </StyledBox>
  );
}
